import { render, staticRenderFns } from "./createPrize.vue?vue&type=template&id=548ec34e&scoped=true&"
import script from "./createPrize.vue?vue&type=script&lang=js&"
export * from "./createPrize.vue?vue&type=script&lang=js&"
import style0 from "./createPrize.vue?vue&type=style&index=0&id=548ec34e&prod&lang=less&scoped=true&"
import style1 from "./createPrize.vue?vue&type=style&index=1&id=548ec34e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ec34e",
  null
  
)

export default component.exports